module.exports = __webpack_public_path__ + "static/media/mz.57ea1e5c.png";